import { createAction, props } from '@ngrx/store';

import { FiscalCustomData, RefundMethod, ReturnAttribute } from '../../components/order-return/domain/models/order-return.models';
import { OrderReturnOption, OrderReturnStep, CashReturnData } from '../../models/returns.models';

import { BankAccount, Order } from '@api/order/order.models';
import { OrderReturnReason } from '@api/return/return.models';
import { PickupPointInfo } from '@api/store-locator/droppoint-lists/models/droppoint-lists.models';
import { Address } from '@features/address';
import { ProductPublicModels } from '@features/products/product';

export const OrderReturnActions = {
    // TODO ECOMDUTI-21038 mejorar cuando se quite de legacy solo cargando el módulo cuando toca en vez de resetear la store
    RESET: '[Order return] RESET',
    SET_RETURN_ORDER: '[Order return] SET_RETURN_ORDER',
    SET_RETURN_ATTRIBUTE_LIST_SUCCESS: '[Order return] SET_RETURN_ATTRIBUTE_LIST_SUCCESS',
    SET_RETURN_ATTRIBUTE_LIST_ERROR: '[Order return] SET_RETURN_ATTRIBUTE_LIST_ERROR',
    SET_RETURN_STEP: '[Order return] SET_RETURN_STEP',
    SET_RETURN_OPTION: '[Order return] SET_RETURN_OPTION',
    SET_RETURN_TYPE: '[Order return] SET_RETURN_TYPE',
    SET_SELECTED_ITEM: '[Order return] SET_SELECTED_ITEM',
    SET_RETURN_SELECTED_REASON: '[Order return] SET_RETURN_SELECTED_REASON',
    SET_RETURN_SELECTED_REVIEW: '[Order return] SET_RETURN_SELECTED_REVIEW',
    SET_RETURN_SELECTED_QUANTITY: '[Order return] SET_RETURN_SELECTED_QUANTITY',
    REMOVE_RETURN_ITEM: '[Order return] REMOVE_RETURN_ITEM',
    SET_RETURN_BOXES: '[Order return] SET_RETURN_BOXES',
    SET_RETURN_ADDRESS: '[Order return] SET_RETURN_ADDRESS',
    NEXT_RETURN_STEP: '[Order return] NEXT_RETURN_STEP',
    SET_CASH_RETURN_DATA: '[Order return] SET_CASH_RETURN_DATA',
    SET_REFUND_BANK_ACCOUNT_DATA: '[Order return] SET_REFUND_BANK_ACCOUNT_DATA',
    SET_FISCAL_DATA: '[Order return] SET_FISCAL_DATA',
    SET_DELIVERY_POINT: '[Order return] SET_DELIVERY_POINT',
    LOAD_MULTINETWORK: '[Order return] LOAD_MULTINETWORK',
    SET_MULTINETWORK: '[Order return] SET_MULTINETWORK',
    LOAD_REASONS_MODAL: '[Order return] LOAD_REASONS_MODAL',
    LOAD_SPECIAL_CONDITIONS_MODAL: '[Order return] LOAD_SPECIAL_CONDITIONS_MODAL',
    LOAD_REFUND_METHODS: '[Order return] LOAD_REFUND_METHODS',
    LOAD_REFUND_METHODS_SUCCESS: '[Order return] LOAD_REFUND_METHODS_SUCCESS',
    LOAD_REFUND_METHODS_ERROR: '[Order return] LOAD_REFUND_METHODS_ERROR',
    SET_SELECTED_REFUND_METHOD: '[Order return] SET_SELECTED_REFUND_METHOD',
    SET_RETURN_REQUEST: '[Order return] SET_RETURN_REQUEST',
};

export const ResetReturn = createAction(OrderReturnActions.RESET);
export const SetReturnRequest = createAction(OrderReturnActions.SET_RETURN_REQUEST);
export const SetReturnOrder = createAction(OrderReturnActions.SET_RETURN_ORDER, props<{ order: Order }>());
export const SetReturnStep = createAction(OrderReturnActions.SET_RETURN_STEP, props<{ step: OrderReturnStep }>());
export const SetReturnOption = createAction(OrderReturnActions.SET_RETURN_OPTION, props<{ option: OrderReturnOption }>());
export const SetReturnSelectedItem = createAction(OrderReturnActions.SET_SELECTED_ITEM, props<{ index: number }>());
export const SetReturnSelectedReason = createAction(
    OrderReturnActions.SET_RETURN_SELECTED_REASON,
    props<{ index: number; reason: OrderReturnReason }>()
);
export const SetReturnSelectedReview = createAction(
    OrderReturnActions.SET_RETURN_SELECTED_REVIEW,
    props<{ index: number; review: string }>()
);
export const SetReturnSelectedQuantity = createAction(
    OrderReturnActions.SET_RETURN_SELECTED_QUANTITY,
    props<{ index: number; returnQuantity: number }>()
);
export const SetReturnBoxes = createAction(OrderReturnActions.SET_RETURN_BOXES, props<{ boxes: number }>());
export const SetReturnAddress = createAction(OrderReturnActions.SET_RETURN_ADDRESS, props<{ address: Address }>());
export const NextReturnStep = createAction(OrderReturnActions.NEXT_RETURN_STEP, props<{ step: OrderReturnStep }>());
export const SetCashReturnData = createAction(
    OrderReturnActions.SET_CASH_RETURN_DATA,
    props<{ cashReturnData: CashReturnData }>()
);
export const SetRefundBankAccountData = createAction(
    OrderReturnActions.SET_REFUND_BANK_ACCOUNT_DATA,
    props<{ bankAccount: BankAccount }>()
);
export const SetFiscalData = createAction(
    OrderReturnActions.SET_FISCAL_DATA,
    props<{ fiscalCustomData: FiscalCustomData }>()
);
export const SetReturnDeliveryPoint = createAction(
    OrderReturnActions.SET_DELIVERY_POINT,
    props<{ deliveryPoint: PickupPointInfo }>()
);
export const LoadReturnMultinetwork = createAction(
    OrderReturnActions.LOAD_MULTINETWORK,
);
export const SetReturnMultinetwork = createAction(
    OrderReturnActions.SET_MULTINETWORK,
    props<{ enabled: boolean }>()
);

export const SetAttributeListSuccess = createAction(
    OrderReturnActions.SET_RETURN_ATTRIBUTE_LIST_SUCCESS,
    props<{ attributeList: ReturnAttribute[] }>()
);

export const SetAttributeListError = createAction(
    OrderReturnActions.SET_RETURN_ATTRIBUTE_LIST_ERROR,
    props<{ error: string }>()
);

export const LoadReasonsModal = createAction(
    OrderReturnActions.LOAD_REASONS_MODAL,
    props<{ index: string }>()
);

export const LoadSpecialConditionsModal = createAction(
    OrderReturnActions.LOAD_SPECIAL_CONDITIONS_MODAL,
    props<{ attributeList: ProductPublicModels.PublicProductAttribute[] }>()
);

export const LoadRefundMethods = createAction(OrderReturnActions.LOAD_REFUND_METHODS);

export const LoadRefundMethodsSuccess = createAction(
    OrderReturnActions.LOAD_REFUND_METHODS_SUCCESS,
    props<{ refundMethods: RefundMethod[] }>()
);

export const LoadRefundMethodsError = createAction(
    OrderReturnActions.LOAD_REFUND_METHODS_ERROR,
    props<{ error: string }>()
);

export const SetSelectedRefundMethod = createAction(
    OrderReturnActions.SET_SELECTED_REFUND_METHOD,
    props<{ refundMethod: RefundMethod }>()
);
